import React from "react";
import "../ViewInvoice.css";
import ErrorPopup from "../../../../components/element/ErrorPopup";
import Loader from "../../../../components/element/Loader";
import NoDataPlaceholder from "../../../../components/element/NoDataPlaceholder";
import { formatToTwoDecimal } from "../../../../utils/utils";
import dayjs from "dayjs";
import { DATE_FORMAT, getOrdinalDateText, LAND_LEASE_TYPE } from "../../../../utils/constants";

const ViewLandLeaseInvoiceTable = ({ invoiceData, isLoading, error }) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (invoiceData && invoiceData.length === 0) {
    return <NoDataPlaceholder />;
  }

  return (
    <div className="view-invoice-table-parent-container">
      <div className="view-invoice-table-container">
        <table className="view-invoice-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Customer Number</th>
              <th>ABO Name</th>
              <th>Submitted At</th>
              <th>Land Use Category</th>
              <th>Lease Start Date</th>
              <th>Lease End Date</th>
              <th>Leased Area (Square Foot)</th>
              <th>Invoice Due Day</th>
              <th>VAT (10%)</th>
              <th>Total Fee</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData?.map((item, index) => (
              <React.Fragment key={index}>
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.dynamicsCustomerNumber}</td>
                  <td>{item?.fboName}</td>
                  <td>
                    {dayjs(item?.submittedAt).utc().format(DATE_FORMAT)}
                  </td>
                  <td>{LAND_LEASE_TYPE.find((status) => status.value === item?.landType)?.name }</td>
                  <td>
                    {dayjs(item?.leaseStartDate).utc().format(DATE_FORMAT)}
                  </td>
                  <td>
                    {dayjs(item?.leaseEndDate).utc().format(DATE_FORMAT)}
                  </td>
                  <td>{item?.leasedArea ?? "---"}</td>
                  <td>{getOrdinalDateText(item?.invoiceDueDay)}</td>
                  <td>{formatToTwoDecimal(item?.tax)}</td>
                  <td>{`BSD ${formatToTwoDecimal(item?.totalFee + item?.tax)}`}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewLandLeaseInvoiceTable;
